export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

export function lerp(start: number, end: number, amount: number) {
  return start + (end - start) * amount;
}

export function inverseLerp(start: number, end: number, value: number) {
  if (start === end) {
    return 0;
  }

  return clamp((value - start) / (end - start), 0, 1);
}
